import { createTheme } from '@mui/material';
import { colorPalette } from './colorPalette';
import { COLOR_MODE } from '../consts';

export const darkMode = createTheme({
  palette: {
    mode: COLOR_MODE.DARK_MODE,
    primary: {
      main: colorPalette.system.primary,
      contrastText: colorPalette.text.primary,
    },
    background: {
      // TODO: Investigate how to get the correct value for this.
      // eslint-disable-next-line
      // @ts-ignore
      dark: colorPalette.background.primary,
    },
  },
  typography: {
    fontFamily: ['"Roboto"', '"sans-serif"'].join(','),
  },
  components: {
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: colorPalette.components.DropDown.background.color,
          border: `1px solid ${colorPalette.background.secondary}`,
          borderRadius: '0px 0px 3px 3px',
          boxShadow: '5px 5px 34px rgba(255, 255, 255, 0.15)',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: colorPalette.components.DropDown.item.hover.color,
          },
        },
        // TODO: Investigate how to set the correct value for this.
        // eslint-disable-next-line
        // @ts-ignore
        'Mui-selected': {
          backgroundColor: colorPalette.components.DropDown.item.selected.color,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: colorPalette.components.DropDown.icon.color,
        },
        select: {
          '&:focus': {
            backgroundColor:
              colorPalette.components.DropDown.item.selected.color,
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          border: 0,
          boxShadow: 'none',
          padding: 0,
          transform: 'unset !important',
          top: '-10rem',
          backgroundColor: 'white',
        },
      },
    },
  },
});
